export default "__VITE_ASSET___5sM8Dx3__"